import React from "react";
import { Box, Container, Grid, Stack } from "@mui/joy";

import AdminAnnouncementStats from "../components/Admin/AdminAnnouncementStats";
import AdminSadhanaStats from "../components/Admin/AdminSadhanaStats";
import AdminAuditLogs from "../components/Admin/AdminAuditLogs";
import DashboardHero from "./dashboard/Hero";
import { MetricsSection } from "./dashboard/MetricsSection";
import { QuotePanel } from "./dashboard/QuotePanel";
import { DashboardQuickActions } from "./dashboard/QuickActions";

export default function AdminDashboard() {
  return (
    <Box>
      <Stack spacing={3}>
        <DashboardHero />
        <MetricsSection />
        <DashboardQuickActions />
        <Grid container spacing={3}>
          <Grid xs={12} lg={8}>
            <Stack spacing={3}>
              <AdminSadhanaStats />
              <AdminAnnouncementStats />
            </Stack>
          </Grid>
          <Grid xs={12} lg={4}>
            <Stack spacing={3}>
              <QuotePanel />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}
